<template>
    <template v-if="hasAuth">
        <slot />
    </template>
    <slot
        v-else
        name="else"
    />
</template>

<script>
import { useUserStore } from '@store/user';

export default {
    name: 'RoleGuard',
    props: {
        guarded: {
            type: Array,
            required: true,
        },
    },
    setup(props) {
        const user = useUserStore();

        const roles = computed(() => {
            return user?.data?.roles;
        });

        const hasAuth = computed(() => {
            if (props.guarded && roles.value) {
                // Admin roles have access to everything
                if (roles.value.includes('OWNER') || roles.value.includes('ADMIN')) {
                    return true;
                }
                // Check if user has any of the guarded roles
                if (props.guarded.some((v) => roles.value.includes(v))) {
                    return true;
                }
            }
            return false;
        });

        return {
            roles,
            hasAuth,
        };
    },
};
</script>
